import { IOpcaoEnum } from '../interfaces/opcao-enum.interface';

export const ICONE_CONCORRENTE_PADRAO = 'fas fa-chess';

export const CAUSA_NOME_DUPLICADO_CONCORRENTE = 'Já existe um concorrente cadastrado com o mesmo nome';

export const CANAIS_MIDIA_SOCIAL: IOpcaoEnum[] = [
  { valor: 1, rotulo: 'Facebook' },
  { valor: 2, rotulo: 'Instagram' },
  { valor: 3, rotulo: 'Linkedin' },
  { valor: 4, rotulo: 'WhatsApp' },
  { valor: 5, rotulo: 'TikTok' },
  { valor: 6, rotulo: 'YouTube' },
  { valor: 7, rotulo: 'X (Twitter)' },
  { valor: 8, rotulo: 'Threads' },
  { valor: 9, rotulo: 'Pinterest' },
  { valor: 10, rotulo: 'Kwai' },
  { valor: 11, rotulo: 'Telegram' },
  { valor: 12, rotulo: 'Spotify' },
  { valor: 99, rotulo: 'Outro' },
];

export const CANAIS_VENDA: IOpcaoEnum[] = [
  { valor: 1, rotulo: 'Direto' },
  { valor: 2, rotulo: 'Loja Virtual' },
  { valor: 3, rotulo: 'Amazon' },
  { valor: 4, rotulo: 'Americanas Marketplace' },
  { valor: 5, rotulo: 'Carrefour Marketplace' },
  { valor: 6, rotulo: 'Casas Bahia Marketplace' },
  { valor: 7, rotulo: 'Centauro' },
  { valor: 8, rotulo: 'Dafiti' },
  { valor: 9, rotulo: 'Magalu Marketplace' },
  { valor: 10, rotulo: 'Mercado Livre' },
  { valor: 11, rotulo: 'Netshoes' },
  { valor: 12, rotulo: 'Shein' },
  { valor: 13, rotulo: 'Shopee' },
  { valor: 14, rotulo: 'Facebook Shops' },
  { valor: 15, rotulo: 'Instagram Shopping' },
  { valor: 16, rotulo: 'TikTok Shop' },
  { valor: 17, rotulo: 'WhatsApp Business' },
];

export const ICONES_DIMENSAO: Record<number, string> = {
  1: 'fas fa-tag',
  2: 'fas fa-truck',
  3: 'fas fa-box',
  4: 'fas fa-headset',
  5: 'fas fa-store',
  6: 'fas fa-hashtag',
  7: 'fas fa-sitemap',
};
